// src/components/Footer.jsx
import React from "react";
import {
  FaInstagram,
  FaFacebookF
} from "react-icons/fa";
import { Link } from "react-router-dom";
import logo from "../assets/images/PriniCrackers.jpg";
import "../styles/Footer.css";

import footerData from "../data/footerData";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        {/* Brand Logo and Description */}
        <div className="footer-brand">
          <img src={logo} alt="Prini Crackers Logo" className="footer-logo" />
          <p>{footerData.brand.description}</p>
        </div>

        {/* Contact Section */}
        <div className="footer-contact">
          <h4>Contact Us</h4>
          <ul>
            {footerData.contact.map((item, index) => (
              <li key={index}>
                {item.icon}{" "}
                <a href={item.href} target="_blank" rel="noopener noreferrer">
                  {item.value}
                </a>
              </li>
            ))}
          </ul>

          {/* Social Media moved here */}
          <div className="footer-social" style={{ marginTop: "1.5rem" }}>
            <h4>Follow Us</h4>
            <div className="social-icons">
              <a
                href={footerData.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
              <a
                href={footerData.social.facebook}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <FaFacebookF />
              </a>
            </div>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-quicklinks">
          <h4>Quick Links</h4>
          <ul>
            {footerData.quickLinks.map((link, index) => (
              <li key={index}>
                <Link to={link.to}>{link.name}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Map Section moved here */}
        <div className="footer-map">
          <h4>Find Us</h4>
          <div className="map-container">
            <iframe
              title="Prini Crackers Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3936.1157425722263!2d77.85455569999999!3d9.4112427!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b06cb0035b81ad9%3A0xa0198dc55a4963e6!2sPrini%20Crackers!5e0!3m2!1sen!2sin!4v1752300448809!5m2!1sen!2sin"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
      

      <div className="footer-bottom">
        <p>
          &copy; {new Date().getFullYear()} {footerData.brand.name}. All rights reserved.
        </p>
      </div>
    </footer>

  );
};

export default Footer;
